import { Contract_GetList } from "@/apis/api.js";

const defaultGrades = [
  { id: 1, displayName: "創業中心代理商", monthlyFee: 1000, salesBonusRate: "0.9", coachingBonusRate: "0.2", peerBonusRate: "0.1", superBonusRate: "0.5", managementBonusRate: "0.2", isYearlyContract: true },
  { id: 2, displayName: "一級代理商", monthlyFee: 500, salsalesBonusRatees: "0.7", coachingBonusRate: "0.2", peerBonusRate: "0.1", superBonusRate: "0.5", managementBonusRate: "0", isYearlyContract: true },
  { id: 3, displayName: "二級代理商", monthlyFee: 300, salesBonusRate: "0.5", coachingBonusRate: "0.2", peerBonusRate: "0.1", superBonusRate: "0.5", managementBonusRate: "0", isYearlyContract: true },
  { id: 4, displayName: "介紹人", monthlyFee: 0, salesBonusRate: "0.3", coachingBonusRate: "0", peerBonusRate: "0.1", superBonusRate: "0.5", managementBonusRate: "0", isYearlyContract: true },
  { id: 5, displayName: "AI勞動教育推廣中心", monthlyFee: 0, salesBonusRate: "0.9", coachingBonusRate: "0.2", peerBonusRate: "0.1", superBonusRate: "0.5", managementBonusRate: "0.2", isPermanentContract: true },
];

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    setGrades(state, grades) {
      state.list = grades;
    },
  },
  actions: {
    async fetchGrades({ commit }) {
      try {
        const res = await Contract_GetList();
        commit("setGrades", res.data);
        console.log("setGrades :", res.data);
        return res.data;
      } catch (err) {
        console.error("取得 grades 失敗：", err);
        commit("setGrades", defaultGrades);
        return defaultGrades;
      }
    },
  },
  getters: {
    all: (state) => state.list,
    byId: (state) => (id) => state.list.find((g) => g.id === id),
  },
};
